import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../app/mainReducer";
import { useIsAuth } from "../../hooks/useIsAuth"
import Layout from "../components/Layout"
import { useParams } from "react-router-dom";
import { useEffect } from 'react'
import { sistemaActions } from "../recucer";
import { ListHeader } from "../components/ListHeader";
import { DefaultButton } from "../components/DefaultButton";
import Loader from "../components/Loader";
import { UserForm } from "../components/UserForm";

export const UsuarioEdit = () => {
  useIsAuth();

  const { id } = useParams();

  const usuario = useSelector((state: RootState) => state.sistema.usuario || null)
  const isLoading = useSelector((state: RootState) => !!state.sistema.isLoading)

  const dispatch = useDispatch()

  useEffect(() => {
    if (!id) return;

    dispatch(sistemaActions.usuarioRequest(id))
  }, [dispatch, id])

  return (
    <Layout>
      <ListHeader label="Usuário">
        <DefaultButton ml={4} to="/usuarios"> Voltar </DefaultButton>
      </ListHeader>

      <Loader isLoading={isLoading} />
      <UserForm currentItem={usuario} />
    </Layout>
  )
}